import { FlowBaseInfo } from '../models/FlowInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Flows } from '../resources/Flows';
import { IResult } from '../ServerApi/types/IResponse';
import { FlowErrors } from '../services/FlowErrors';
import { ActionHelpers } from './ActionHelpers';
import { actionSuccessTranslation, actionErrorTranslation } from './ContentActionNotification';
import { Messages } from '../../codegen/Localize';

export class ChangeFlowDescriptionAction {

  public static $inject = ['Flows', 'FlowErrors'];

  constructor(
    private Flows: Flows,
    private FlowErrors: FlowErrors
  ) { }

  public execute(flow: FlowBaseInfo, newDescription: string): ng.IPromise<IResult> {

    return this.Flows.setDescription(flow.id, newDescription).then((result: IResult) => {
        ActionHelpers.notifyStandardError(
          Set.singletonForIdItem(flow),
          result,
          {
            success: actionSuccessTranslation(Messages.editDescriptionSuccessful),
            error: actionErrorTranslation(Messages.editDescriptionFailure),
          },
          (errorItem: IErrorItem<FlowBaseInfo>) => this.FlowErrors.errorDetailsFor(errorItem)
        );
        return result;
    });
  }
}

Module.instance().service('ChangeFlowDescriptionAction', ChangeFlowDescriptionAction);
